import React from 'react';

import type { TriggerProps } from '@atlaskit/popup';

import type { ProductKeys3P } from '../../../common/constants/products';
import { OAuthWarningWrapper } from '../../../common/ui/oauth-warning-wrapper';
import { OAuthSource } from '../../../common/utils/events/oauth-events';
import { isProductSmartlink } from '../../../common/utils/oauth-container';
import { ErrorBoundary } from '../../../controllers/error-boundary';
import { useIsUserOAuthed, useOAuthHandlers } from '../../../controllers/oauth';
import { useBootstrap } from '../../../controllers/store';
import { useQuickFindQuery } from '../../../controllers/store/quick-find';

export const AppButtonFor3PApps = ({
	productKey,
	redirectToFPSWithProductSelected,
	trigger,
}: {
	productKey: ProductKeys3P;
	redirectToFPSWithProductSelected: () => void;
	trigger: (props: { triggerProps?: TriggerProps; userNeedsAuth: boolean }) => JSX.Element;
}): React.JSX.Element => {
	const [{ thirdPartyConfigs }] = useBootstrap();
	const isSmartlink = isProductSmartlink({ productKey, thirdPartyConfigs });
	const { userNeedsOAuth } = useIsUserOAuthed(productKey);
	const quickFindQuery = useQuickFindQuery();

	if (userNeedsOAuth) {
		return (
			<ErrorBoundary section="FiltersRowAppButtonFor3PAppsOAuthWrapper">
				<OAuthWarningWrapper
					key={productKey}
					product={productKey}
					postAuthAction={() => {
						redirectToFPSWithProductSelected();
					}}
					trigger={(triggerProps) => trigger({ ...triggerProps, userNeedsAuth: true })}
					isOnSearchDialog={false}
					isInline={true}
					useOAuthHandlers={useOAuthHandlers}
					useIsUserOAuthed={useIsUserOAuthed}
					isSmartlink={isSmartlink}
					searchQuery={quickFindQuery}
					oAuthSource={OAuthSource.quickFindFilter}
					thirdPartyConfigs={thirdPartyConfigs}
				/>
			</ErrorBoundary>
		);
	}

	return trigger({ userNeedsAuth: false });
};
